import React from 'react'

import {
  AlignItems,
  Box,
  Display,
  FlexDirection,
  JustifyContent,
} from '@gousto-internal/citrus-react'

import { Cta, useGetCtaProps } from 'routes/Home/Cta'
import { ComparisonTable } from 'routes/Home/PriceComparisonTable/components/ComparisonTable/ComparisonTable'
import { WelcomeSection } from 'routes/Home/PriceComparisonTable/components/WelcomeSection/WelcomeSection'
import { BLOCK_WIDTH_LIST } from 'routes/Home/PriceComparisonTable/constants'

export const PriceComparisonTable = () => {
  const { ctaUri, ctaText } = useGetCtaProps({ withDiscount: true })

  return (
    <Box display={Display.Flex} justifyContent={JustifyContent.Center}>
      <Box
        data-testid="PriceComparisonTable"
        display={Display.Flex}
        flexDirection={[FlexDirection.Column, null, FlexDirection.Row]}
        justifyContent={[JustifyContent.Center, null, JustifyContent.SpaceBetween]}
        alignItems={AlignItems.Center}
        maxWidth="1200px"
        paddingV={10}
        paddingBottom={6}
        paddingH={[2, 4, 8]}
        gap={4}
        width="100%"
      >
        <Box
          width={BLOCK_WIDTH_LIST}
          display={Display.Flex}
          flexDirection={FlexDirection.Column}
          alignItems={[AlignItems.Center, null, AlignItems.FlexStart]}
        >
          <WelcomeSection />
          {/* we show CTA under WelcomeSection at 960px+ */}
          <Box display={[Display.None, null, Display.Block]} width="17.5rem">
            <Cta ctaUri={ctaUri} trackingSectionName="priceComparison">
              {ctaText}
            </Cta>
          </Box>
        </Box>
        <ComparisonTable />
      </Box>
    </Box>
  )
}
